import React from 'react';
import { Viewer, Worker  } from '@react-pdf-viewer/core';
import CloseIcon from '@mui/icons-material/Close';

import {
  Alert,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';

import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { printPlugin } from '@react-pdf-viewer/print';

// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

export const ViewPDFGlobal = ({open = false, dataReporte = {}, setOpen}) => {

  const fileUrl = typeof dataReporte?.link === 'string' ? dataReporte.link.trim() : '';
  const hasFile = fileUrl.length > 0;

  // * INSTANCIA PARA DESCARGAR EL PDF Y ASIGNAR UN NOMBRE POR DEFECTO.
  const getFilePluginInstance = getFilePlugin({
    fileNameGenerator: () => {
      return dataReporte?.nombre;
    },
  });

  // * INSTANCIA PARA IMPRIMIR LA PAGINA.
  const printPluginInstance = printPlugin();

  // * BOTONES.
  const { DownloadButton } = getFilePluginInstance;
  const { PrintButton } = printPluginInstance;

  // * FUNCION PARA CERRAR EL MODAL.
  const cancelAction = () => {
    setOpen({enabled: false, file: {}});
  };

  return (
    
    <Dialog
    PaperProps={{ sx: { width: "50%", height: "90%" } }}
    open={open}
    maxWidth='lg'
    >

      <DialogContent>

        <div
          className="rpv-core__viewer"
          style={{
              border: '1px solid rgba(0, 0, 0, 0.3)',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
          }}
          >
            {hasFile && <div
                style={{
                    alignItems: 'center',
                    backgroundColor: '#eeeeee',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    padding: '4px',
                }}
            >
                <DownloadButton />
                <PrintButton />
            </div>}
            
            <div
                style={{
                    flex: 1,
                    overflow: 'hidden',
                }}
            >
              {hasFile ? (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl={fileUrl}
                    plugins={[getFilePluginInstance, printPluginInstance]}
                    renderError={() => <Alert severity="error">No fue posible mostrar este archivo PDF.</Alert>}
                  />
                </Worker>
              ) : (
                <Alert severity="warning">El archivo PDF no está disponible.</Alert>
              )}
            </div>
          </div>

      </DialogContent>

      <DialogActions className='justify-content-center'>
        <button type="button" onClick={() => cancelAction()} className='btn btn-danger'><CloseIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>SALIR</button>
      </DialogActions>

    </Dialog>

  );
};
